import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { LayoutModule } from '@angular/cdk/layout';

import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';

import { AppRoutingModule } from 'app-routing.module';
import { AppComponent } from 'app.component';

import { AuthGuard } from 'guards/auth/auth.guard';

import { SigninComponent } from 'modules/home/signin/signin.component';

import { SharedModule } from 'modules/shared/shared.module';
import { OrganizationUnitsModule } from 'modules/organization-units/organization-units.module';

import { TokenService } from 'services/token/token-service.service';
import { AppService } from 'services/app/app.service';
import { ConfigService } from 'services/config/config.service';
import { UserService } from 'services/user/user.service';
import { OrganizationUnitService } from 'services/organization-unit/organization-unit.service';
import { ArcgisMapService } from 'services/arcgis-map/arcgis-map.service';
import { TokenInterceptor } from 'interceptors/token.interceptor';

@NgModule({
  declarations: [
    AppComponent,
    SigninComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    SharedModule,
    OrganizationUnitsModule,
    NoopAnimationsModule,
    LayoutModule,
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    MatDialogModule,
    MatButtonModule,
    MatCheckboxModule,
    MatMenuModule,
  ],
  exports: [
    MatIconModule,
    SharedModule,
  ],
  providers: [
    TokenService,
    AppService,
    UserService,
    ConfigService,
    OrganizationUnitService,
    AuthGuard,
    ArcgisMapService,
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
